import React from 'react';

const TeamMembers: React.FC = () => {
  return (
    <section className="section team-members" id="team-members">
      <div className="container">
        <div className="section-header">
          <div className="terminal-window section-title-terminal">
            <div className="terminal-header">
              <div className="terminal-dots">
                <div className="terminal-dot red pulse"></div>
                <div className="terminal-dot yellow pulse"></div>
                <div className="terminal-dot green pulse"></div>
              </div>
              <span className="terminal-window-title">/dev/nerds</span>
            </div>
            <div className="terminal-content">
              <div className="terminal-line">
                <span className="terminal-prompt">PaidNerd@team:~$</span>{' '}
                <span className="terminal-command">cat team_members.json | head -10</span>
              </div>
              <div className="terminal-output">
                <span className="highlight-cyan">👥 Meet our development team</span><br />
                <span className="highlight-green">💻 Passionate developers crafting digital solutions</span><br />
                <span className="highlight-yellow">🚀 Building the future of web development</span>
              </div>
            </div>
          </div>
        </div>

        <div className="team-grid">
          {/* Team Member 1 - Atabak Rafati */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_001.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-1.svg" 
                      alt="atabak rafati" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">atabak rafati</div>
                      <div className="member-role highlight-cyan">full-stack developer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• Frontend & Backend Development</div>
                      <div className="skill-item">• Database Architecture</div>
                      <div className="skill-item">• API Development & Integration</div>
                      <div className="skill-item">• DevOps & Cloud Solutions</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 2 - Backend Developer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_002.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-2.svg" 
                      alt="backend developer" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">reza karimi</div>
                      <div className="member-role highlight-cyan">backend developer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• Server-Side Architecture</div>
                      <div className="skill-item">• RESTful API Design</div>
                      <div className="skill-item">• Database Management & Optimization</div>
                      <div className="skill-item">• Microservices Development</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 3 - DevOps Engineer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_003.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-3.svg" 
                      alt="nila rezapour" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">nila rezapour</div>
                      <div className="member-role highlight-cyan">devops engineer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• CI/CD Pipeline Management</div>
                      <div className="skill-item">• Cloud Infrastructure (AWS, Azure)</div>
                      <div className="skill-item">• Container Orchestration (Docker, Kubernetes)</div>
                      <div className="skill-item">• Infrastructure as Code</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 4 - Frontend Developer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_004.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-4.svg" 
                      alt="nima jafari" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">nima jafari</div>
                      <div className="member-role highlight-cyan">frontend developer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• React & Modern JavaScript</div>
                      <div className="skill-item">• Responsive Web Design</div>
                      <div className="skill-item">• Performance Optimization</div>
                      <div className="skill-item">• Component-Based Architecture</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 5 - Mobile Developer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_005.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-5.svg" 
                      alt="armin bagheri" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">armin bagheri</div>
                      <div className="member-role highlight-cyan">mobile developer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• iOS & Android Development</div>
                      <div className="skill-item">• React Native & Flutter</div>
                      <div className="skill-item">• Mobile UI/UX Patterns</div>
                      <div className="skill-item">• App Store Deployment</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 6 - Data Engineer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_006.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-6.svg" 
                      alt="elahe rahimi" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">elahe rahimi</div>
                      <div className="member-role highlight-cyan">data engineer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• Data Pipeline Development</div>
                      <div className="skill-item">• Big Data Technologies</div>
                      <div className="skill-item">• ETL Process Design</div>
                      <div className="skill-item">• Data Warehousing Solutions</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 7 - Security Engineer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_007.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-7.svg" 
                      alt="hossein abbasi" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">hossein abbasi</div>
                      <div className="member-role highlight-cyan">security engineer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• Application Security Testing</div>
                      <div className="skill-item">• Penetration Testing & Vulnerability Assessment</div>
                      <div className="skill-item">• Security Best Practices Implementation</div>
                      <div className="skill-item">• Threat Detection & Prevention</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Member 8 - UI/UX Designer */}
          <div className="team-member-card">
            <div className="terminal-window team-terminal">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <div className="terminal-dot red"></div>
                  <div className="terminal-dot yellow"></div>
                  <div className="terminal-dot green"></div>
                </div>
                <span className="terminal-window-title">member_008.dev</span>
              </div>
              <div className="terminal-content">
                <div className="team-member-info">
                  <div className="team-member-photo">
                    <img 
                      src="/team-member-8.svg" 
                      alt="sara hosseini" 
                      className="member-avatar"
                    />
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="team-member-details">
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">whoami</span>
                    </div>
                    <div className="terminal-output">
                      <div className="member-name highlight-green">sara hosseini</div>
                      <div className="member-role highlight-cyan">ui/ux designer</div>
                    </div>
                    <div className="terminal-line">
                      <span className="terminal-prompt">$</span>{' '}
                      <span className="terminal-command">cat skills.txt</span>
                    </div>
                    <div className="terminal-output">
                      <div className="skill-item">• UI/UX Design & Prototyping</div>
                      <div className="skill-item">• User Research & Testing</div>
                      <div className="skill-item">• Design Systems & Style Guides</div>
                      <div className="skill-item">• Interaction Design & Wireframing</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamMembers;
